'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmailish = require('./isEmailish');

var _isEmailish2 = _interopRequireDefault(_isEmailish);

var _cleanUp = require('./cleanUp');

var _cleanUp2 = _interopRequireDefault(_cleanUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (link) {
  var removeQueryParams = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];

  if ((0, _isEmailish2.default)(link)) {
    return link;
  }

  link = (0, _cleanUp2.default)(link, removeQueryParams);

  // if there is no sub paths e.g. site.com
  if (link.indexOf('/') < 0) {
    return link;
  }

  var fragments = link.split('/');
  if (fragments.length > 2) {
    return fragments.shift() + '/.../' + fragments.pop();
  }

  return fragments.shift() + '/' + fragments.pop();
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/linkhunter/lib/beautify.js
 ** module id = 106
 ** module chunks = 0
 **/